"use strict";

var _httpCore = _interopRequireDefault(require("../httpCore"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * 将记录移至顶部
 */

/**
 * 参数：{ resid, recid, strOrderCol, strGroupWhere }
 * 1. resid:资源 id；必选
 * 2. recid:记录 id；必选
 * 3. strOrderCol: 排序字段的内部字段名；必选
 * 4. strGroupWhere: 分类排序的 where 子句；可选
 */


_httpCore.default.createApi('moveUpFirst', {
  method: 'get',
  url: '/api/Resource/MoveUpFirst'
});